import { render, staticRenderFns } from "./Ecran.vue?vue&type=template&id=27cc0b13&scoped=true"
import script from "./Ecran.vue?vue&type=script&lang=js"
export * from "./Ecran.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cc0b13",
  null
  
)

export default component.exports